import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  entityTiposActividadLoadFailure,
  entityTiposActividadLoadSuccess,
  entityTiposActividadLoadRequest
} from './entity-tipos-actividad.actions';
import { TiposActividadService } from '@rpe/registro-personas-empresas-lib';

@Injectable()
export class TiposActividadEffects {
  // load
  loadRequestTiposActividad = createEffect(() =>
    this.actions$.pipe(
      ofType(entityTiposActividadLoadRequest),
      mergeMap(() =>
        this.tiposActividadService.getTiposActividad().pipe(
          map((items) => entityTiposActividadLoadSuccess({ items })),
          catchError((error) => of(entityTiposActividadLoadFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private tiposActividadService: TiposActividadService
  ) {
    this.tiposActividadService.url = environment.apiUrl;
  }
}
